/* eslint-disable jsx-a11y/no-onchange */
import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  filterByCustomerExcludedState,
  // eslint-disable-next-line prettier/prettier
  filterByCustomerSelectedState,
  // eslint-disable-next-line prettier/prettier
  setNewState
} from '../../features/offerSearch/offerSearchSlice';
import { RootState } from '../../redux/rootReducer';
import { States_US } from '../../util/States';
import { LOC } from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import './ViewDestinationHeader.scss';

const ViewDestinationHeader: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const offerLocation = useSelector((state: RootState) => state.offerDetails.primaryOfferLocations);
  const prospectOriginalState = useSelector((state: RootState) => state.offerDetails.prospectOriginalState);
  const customerSelectedStateCode = useSelector((state: RootState) => state.offerDetails.customerSelectedStateCode);
  const customerExcludedStateCode = useSelector((state: RootState) => state.offerDetails.customerExcludedStateCode);
  const searchParameter = useSelector((state: RootState) => state.offerDetails.searchParameter);
  const modeLoc = searchParameter.mode === LOC ? true : false;

  const dispatch = useDispatch();
  const onCustomerExcludedStateChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue !== '-1') {
      dispatch(setNewState(selectedValue));
    } else {
      if (modeLoc) {
        dispatch(setNewState(undefined));
      } else {
        dispatch(setNewState(prospectOriginalState));
      }
    }

    dispatch(filterByCustomerExcludedState(e.target.value));
  };
  const onCustomerSelectedStateChange = (e) => {
    dispatch(filterByCustomerSelectedState(e.target.value));
  };
  const optionsCustomerState = States_US.map((e, index) => {
    return (
      <option value={e.code} key={index}>
        {e.name}
      </option>
    );
  });
  const optionsOfferLocation = offerLocation?.map((e, index) => {
    return (
      <option value={e.stateCode} key={index}>
        {e.stateName}
      </option>
    );
  });
  return (
    <div>
      <div className="row">
        <div className="col-md-4">
          <div className="destinationHeader upperCase">
            <h3>{localize('preview-sales-engine.static-content.copy.select-destination-page.header')}</h3>
          </div>
        </div>
        <div className="col-md-4 form-row state-custom-style customer-state">
          <div className="form-group upperCase custom-style-state">
            <div>
              <label htmlFor="onCustomerExcludedStateChange" className="state-label">
                <span>
                  {localize(
                    'preview-sales-engine.static-content.copy.select-destination-page.select-prospect-state-dropdown',
                  )}
                </span>
                <select
                  onChange={onCustomerExcludedStateChange}
                  className="form-control upperCase"
                  id="onCustomerExcludedStateChange"
                  defaultValue={customerExcludedStateCode}
                >
                  <option value={-1}>
                    {localize('preview-sales-engine.static-content.copy.eligibility-page.select-state-default')}
                  </option>
                  {optionsCustomerState}
                </select>
              </label>
              {modeLoc ? (
                customerExcludedStateCode ? (
                  <></>
                ) : (
                  <div className="invalid-feedback-onchange">
                    {localize(
                      'preview-sales-engine.static-content.copy.select-destination-page.select-a-prospect-state',
                    )}
                  </div>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4 form-row state-custom-style customer-state">
          <div className="form-group upperCase custom-style-state">
            <label htmlFor="onCustomerSelectedStateChange" className="state-label">
              <span>
                {localize('preview-sales-engine.static-content.copy.select-destination-page.select-region-dropdown')}
              </span>
              <select
                onChange={onCustomerSelectedStateChange}
                className="form-control upperCase"
                id="onCustomerSelectedStateChange"
                defaultValue={customerSelectedStateCode}
              >
                <option value={-1}>
                  {localize('preview-sales-engine.static-content.copy.eligibility-page.select-state-default')}
                </option>
                {optionsOfferLocation}
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLocalization(ViewDestinationHeader);
